import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const authServerUrl = process.env.AUTH_SERVER_URL || "https://account.wildsky.dev";
const authEditorClientId = process.env.AUTH_EDITOR_CLIENT_ID || "8D32D354C791CDD5-A3EaRX6saqtKtLrYFAbNRDRDYLSVYwyE.dcei.wildsky.dev";

function formatError(error) {
    if (typeof error === "string") {
        return <span style={{ color: "red" }}>{error}</span>;
    }
    return <pre style={{ color: "red" }}>{JSON.stringify(error, null, 4)}</pre>;
}

function formatQuery(o) {
    return Object.keys(o)
        .map((i) => `${encodeURIComponent(i)}=${encodeURIComponent(o[i])}`)
        .join("&");
}

class LoginWithState extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: null,
            token: null,
        };
    }

    componentDidMount() {
        this.get();
    }

    async get() {
        const response = await fetch(
            `/api/signin/get?id=${this.props.match.params.id}`
        );
        const result = await response.json();
        if (result.error) {
            this.setState({ loading: false, error: result.error });
            return;
        }
        this.setState({ loading: false, token: result.token });
    }

    render() {
        if (this.state.loading) {
            return "Loading...";
        }
        if (this.state.error) {
            return formatError(this.state.error);
        }
        if (!this.state.token) {
            const params = {
                response_type: "code",
                redirect_uri: window.location.origin + "/auth/signin",
                client_id: authEditorClientId,
                scope: "openid profile email permissions offline_access",
                prompt: "consent",
                state: this.props.match.params.id,
            };
            const authUrl = `${authServerUrl}/auth?${formatQuery(params)}`;
            window.location.href = authUrl;
            return (
                <div>
                    Redirecting to <a href={authUrl}>Auth Server</a>
                </div>
            );
        }
        return <div>Success</div>;
    }
}

class CheckLogin extends React.PureComponent {
    constructor(props) {
        super(props);

        const args = window.location.search
            .substring(1)
            .split("&")
            .map((p) => p.split("=").map((i) => decodeURIComponent(i)));
        let code = null;
        let state = null;
        for (let p of args) {
            if (p[0] === "code") {
                code = p[1];
            } else if (p[0] === "state") {
                state = p[1];
            }
        }

        this.state = {
            id: state | 0,
            code,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.auth();
    }

    async auth() {
        const loginResult = await (
            await fetch("/api/login/v2", {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    code: this.state.code,
                }),
            })
        ).json();
        if (loginResult.result !== "OK") {
            this.setState({ loading: false, error: loginResult.error });
            return;
        }
        const setTokenResponse = await fetch("/api/signin/set/v2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: this.state.id,
                token: loginResult.token,
                refreshToken: loginResult.refreshToken,
            }),
        });
        const result = await setTokenResponse.json();
        if (result.error) {
            this.setState({ loading: false, error: result.error });
            return;
        }
        this.setState({ loading: false });
    }

    render() {
        if (this.state.loading) {
            return "Login...";
        }
        if (this.state.error) {
            return formatError(this.state.error);
        }
        return <Redirect to={`/auth/signin/${this.state.id}`} />;
    }
}

export default class Entry extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div>
                    <Switch>
                        <Route
                            path='/auth/signin/:id'
                            component={LoginWithState}
                        />
                        <Route component={CheckLogin} />
                    </Switch>
                </div>
            </div>
        );
    }
}
